export enum TeamingStatus {
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  STARTED = 'STARTED',
  NONE = 'NONE',
}
